import { z } from "zod";

/**
 * A My work view's address: the issue in its peek, and for Assigned to me its grouping. Its own module, as the routes'
 * address rules are loaded with the app itself, before any page's code (BUILD_SPEC §4.2): the page's stays split off.
 */
export const myWorkSearchSchema = z.object({
  issue: z.string().min(1).optional().catch(undefined),
  group: z.enum(["category", "project"]).optional().catch(undefined),
});
export type MyWorkSearch = z.infer<typeof myWorkSearchSchema>;
